import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "sr-only"
}
const _hoisted_2 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_router_link, {
      to: _ctx.to,
      class: _normalizeClass(_ctx.iconOnly ? 'd-flex align-items-center' : '')
    }, {
      default: _withCtx(() => [
        (_ctx.iconOnly)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["icon", _ctx.iconClass]),
              "aria-hidden": "true"
            }, null, 2))
          : _createCommentVNode("", true),
        (_ctx.iconOnly)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.tcRequired ? _ctx.$tc(_ctx.i18nMessage, _ctx.i18nCount) : _ctx.$t(_ctx.i18nMessage)), 1))
          : _createCommentVNode("", true),
        (!_ctx.iconOnly)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.tcRequired ? _ctx.$tc(_ctx.i18nMessage, _ctx.i18nCount) : _ctx.$t(_ctx.i18nMessage)), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["to", "class"])
  ]))
}